import { SUBCATEGORIES_API, SUBCATEGORY_NI_API } from '../../../../Utilities/APIs'
import PcINSTCRUD from '../../../Partials/Layouts/CRUDs/CRUDLayouts/INSTCRUD/PcINSTCRUD'

function SubcategoryNICards() {
  return (
    <PcINSTCRUD
        // parentChild props
        parentDBField={'subcategory'}

        // common props
        api={SUBCATEGORY_NI_API}
        screenTopicSingular={'Subcategory NI'}
        screenTopicPlural={'Subcategory NIs'}
        
        // crud header props
        showTotalInHeading
        
        // crud props
        allowCreate
        allowUpdate
        allowDelete
        
        // select props
        selectApi={SUBCATEGORIES_API}
        selectType={'parent-child'}
        selectDBField={'subcategory'}
        selectName={'Subcategory'}

        textDBField='engName'
        textName='English Name'
    />
  )
}

export default SubcategoryNICards